export default __webpack_public_path__ + "static/media/neet_web_banner_asset.0412eac0.png";